import Vue from "vue";
import productService from "../../services/product/product";
import { Product } from "../../services/product/entities/product.interface";
import { uploadTask, deleteTask } from "../../firebase";
import constants from "../../config/constants";
import { ProductState } from "./states/product.state.interface";

export default {
  namespaced: true,
  state: {
    products: [],
    totalProducts: 0
  },
  getters: {
    getProducts: (state: ProductState) => state.products,
    getTotalProducts: (state: ProductState) => state.totalProducts
  },
  mutations: {
    setProducts(state: ProductState, products: Array<Product>) {
      Vue.set(state, "products", products);
    },
    setTotalProducts(state: ProductState, totalProducts: number) {
      Vue.set(state, "totalProducts", totalProducts);
    }
  },
  actions: {
    getProducts: async (context: any, payload: any) => {
      context.commit("setProducts", []);
      await productService.getProducts(payload).then((response: any) => {
        context.commit("setTotalProducts", response.data.totalProducts);
        context.commit("setProducts", response.data.products);
      });
    },
    getProductsToClient: async (context: any) => {
      await productService.getProductsToClient().then((response: any) => {
        context.commit("setProducts", response.data.products);
      });
    },
    createProduct: async (context: any, payload: any) => {
      let created = false;
      await productService
        .createProduct(payload)
        .then(async (response: any) => {
          created = response.data.created;
          const photoURL = await uploadTask(
            response.data.productID,
            constants.TABLE.PRODUCT,
            payload.photoUrl
          );
          await productService.updateProduct({
            productId: response.data.productID,
            photoUrl: photoURL
          });
          await productService.getProducts(payload).then((response: any) => {
            context.commit("setTotalProducts", response.data.totalProducts);
            context.commit("setProducts", response.data.products);
          });
        });
      return created;
    },
    updateProduct: async (context: any, payload: any) => {
      let updated = false;
      if (payload.newPhoto) {
        const photoURL = await uploadTask(
          payload.productId,
          constants.TABLE.PRODUCT,
          payload.photoUrl
        );
        payload.photoUrl = photoURL;
        await deleteTask(payload.currentPhoto);
      }

      if (payload.status == constants.STATUS.DELETED) {
        await deleteTask(payload.photoUrl);
        payload.photoUrl = "deleted";
      }
      await productService
        .updateProduct(payload)
        .then(async (response: any) => {
          updated = response.data.updated;
          await productService
            .getProducts(payload)
            .then(async (response: any) => {
              if (payload.page > 1 && response.data.products.length == 0) {
                payload.start =
                  (payload.page - 1) * constants.ITEMS_PER_PAGE -
                  constants.ITEMS_PER_PAGE;
                await productService
                  .getProducts(payload)
                  .then((response: any) => {
                    context.commit(
                      "setTotalProducts",
                      response.data.totalProducts
                    );
                    context.commit("setProducts", response.data.products);
                  });
              } else {
                context.commit("setTotalProducts", response.data.totalProducts);
                context.commit("setProducts", response.data.products);
              }
            });
        });
      return updated;
    },
    addLicenseToProduct: async (context: any, payload: any) => {
      let created = false;
      await productService
        .addLicenseToProduct(payload)
        .then(async (response: any) => {
          created = response.data.created;
          await productService.getProducts(payload).then((response: any) => {
            context.commit("setTotalProducts", response.data.totalProducts);
            context.commit("setProducts", response.data.products);
          });
        });
      return created;
    },
    updateLicenseToProduct: async (context: any, payload: any) => {
      let updated = false;
      await productService
        .updateLicenseToProduct(payload)
        .then(async (response: any) => {
          updated = response.data.updated;
          await productService.getProducts(payload).then((response: any) => {
            context.commit("setTotalProducts", response.data.totalProducts);
            context.commit("setProducts", response.data.products);
          });
        });
      return updated;
    },
    deleteLicenseToProduct: async (context: any, payload: any) => {
      let deleted = false;
      await productService
        .deleteLicenseToProduct(payload.licenseID)
        .then(async (response: any) => {
          deleted = response.data.deleted;
          await productService.getProducts(payload).then((response: any) => {
            context.commit("setTotalProducts", response.data.totalProducts);
            context.commit("setProducts", response.data.products);
          });
        });
      return deleted;
    }
  }
};
